import { Box, Skeleton, Typography } from '@mui/material';
import { useBuilderVocabulary } from '../../hooks/useBuilderVocabulary';
import { BuilderVocabularyItem } from '../../types/SimilarlySituated/BuilderVocabularyItem.type';
import { BuilderVocabulary } from '../../types/SimilarlySituated/BuilderVocabulary.type';

const labelStyle = {
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.08em',
  color: '#718096',
  marginBottom: '6px',
};

interface VocabularyListFieldProps {
  label: string;
  vocabulary: BuilderVocabulary;
  values: BuilderVocabularyItem[];
  onChange: (values: BuilderVocabularyItem[]) => void;
}

function VocabularyListField({ label, vocabulary, values, onChange }: VocabularyListFieldProps) {
  const { data: options, isPending, isError } = useBuilderVocabulary(vocabulary);

  if (isError) return null;

  const toggle = (option: BuilderVocabularyItem) =>
    onChange(
      values.some((value) => value.id === option.id)
        ? values.filter((value) => value.id !== option.id)
        : [...values, option],
    );

  return (
    <Box>
      <Typography sx={labelStyle}>{label}</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          padding: '10px 20px 10px 0',
          maxHeight: 300,
          overflowY: 'auto',
        }}
      >
        {isPending && <Skeleton variant='rounded' height={38} />}
        {options?.map((option) => {
          const isSelected = values.some((value) => value.id === option.id);

          return (
            <Box
              key={option.id}
              component='button'
              type='button'
              onClick={() => toggle(option)}
              sx={{
                borderRadius: '6px',
                border: `1px solid ${isSelected ? '#7DD3FC' : '#A0AEC0'}`,
                backgroundColor: isSelected ? '#E0F2FE' : '#fff',
                color: isSelected ? '#0369A1' : '#4A5568',
                fontSize: '13px',
                fontWeight: isSelected ? 500 : 400,
                padding: '10px 14px',
                textAlign: 'left',
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                '&:hover': { borderColor: isSelected ? 'none' : '#CBD5E0', color: isSelected ? '#0369A1' : '#6e7478' },
              }}
            >
              {option.name}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default VocabularyListField;
